export default {
  auth: () => import("/usr/src/app/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m),
  error: () => import("/usr/src/app/layouts/error.vue").then(m => m.default || m),
  "register-flow": () => import("/usr/src/app/layouts/register-flow.vue").then(m => m.default || m)
}